import * as React from "react";
import {forwardRef, useEffect, useRef, useState} from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {Autocomplete, TextField, Tooltip} from "@mui/material";
import userService from "../../../services/UserService";
import taskTypeService from "../../../services/TaskTypeService";
import html2pdf from 'html2pdf.js';
import Button from "@mui/material/Button";
import {Print} from "@mui/icons-material";

const headerCell = {
    fontWeight: "700 !important",
    textAlign: "center",
    backgroundColor: "rgba(245,120,95,0.59)",
}

const hideBorderBottom = {'& ::before': {border: "none !important"}}

const printableFieldStyle = {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
}

export default function DefectReport() {

    const componentRef = useRef();
    const handlePrint = () => {
        const element = componentRef.current;
        const options = {
            margin: 0.2,
            filename: 'selejt-jelentes.pdf',
            image: {type: 'jpeg', quality: 1},
            html2canvas: {scale: 4},
            jsPDF: {unit: 'in', format: 'a4', orientation: 'portrait'}
        };
        html2pdf().set(options).from(element).save();
    };

    const [users, setUsers] = useState([]);
    const [taskTypes, setTaskTypes] = useState([]);
    useEffect(() => {
        userService.getSelectors().then(setUsers).catch(console.error);
        taskTypeService.getSelectors().then(setTaskTypes).catch(console.error);
    }, []);

    const [formData, setFormData] = useState({})
    const handleChange = (e, v, n) => {
        const name = n || e.target.name
        const value = v || e.target.value
        console.log(name, value)
        setFormData((prev) => ({
            ...prev,
            [name]: value, // update the field by its name
        }));
    };

    return (
        <>
            <div style={{display: "flex", alignItems: "start", justifyContent: "center", gap: "10px"}}>
                <PrintableComponent users={users} taskTypes={taskTypes} handleChange={handleChange} formData={formData}/>
                <Tooltip title="Nyomtatás">
                    <Button onClick={handlePrint} variant="contained" sx={{
                        backgroundColor: 'rgba(51,51,51,0.7)',
                        color: '#fff',
                        '&:hover': {backgroundColor: 'rgba(51,51,51,0.8)'},
                        borderRadius: "20px"
                    }}>
                        <Print sx={{margin: "0px", fontSize: '90px'}}/>
                    </Button>
                </Tooltip>
            </div>

            <div style={{display: "none"}}>
                <PrintableDefectReport ref={componentRef} data={formData}/>
            </div>

        </>
    )
}

const PrintableComponent = forwardRef((props, ref) => {

    return (
        <div ref={ref}>
            <Paper sx={{margin: "auto", width: "200mm", height: "287mm", marginBottom: "20px"}}>
                <Table sx={{
                    '& textarea': {whiteSpace: 'pre-wrap !important', wordWrap: "break-word !important", fontSize: "16px !important"},
                    '& td': {border: '1px solid black', padding: "2px !important", fontSize: "16px !important", tableLayout: "fixed"},
                    '& td div': {padding: "0px !important", fontSize: "16px !important"}
                }}>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={4} sx={headerCell}>Selejt jelentés</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={1} sx={headerCell}>Projektszám</TableCell>
                            <TableCell colSpan={1} sx={headerCell}>Munkaszám</TableCell>
                            <TableCell colSpan={2} sx={headerCell}>Selejt mennyiség</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={1}>P123</TableCell>
                            <TableCell colSpan={1}>M123</TableCell>
                            <TableCell colSpan={2}>
                                <TextField type="text" fullWidth={true} variant="standard"
                                           onChange={props.handleChange}
                                           name={"amount"}
                                           sx={hideBorderBottom}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2} sx={headerCell}>Hiba okozó neve</TableCell>
                            <TableCell colSpan={2} sx={headerCell}>Munkadarab megnevezése</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <Autocomplete getOptionLabel={(user) => user.name} popupIcon={null}
                                              sx={hideBorderBottom}
                                              multiple={true}
                                              renderTags={(selected) => selected.map(u => u.name).join(', ')}
                                              onChange={(e, v) => props.handleChange(e, v, "defectCausers")}
                                              renderInput={(params) => (
                                                  <TextField {...params} variant="standard"/>
                                              )} options={props.users || []}/>
                            </TableCell>
                            <TableCell colSpan={2}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} onChange={props.handleChange} name={"nameOfWorkpiece"}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>Selejt anyaga</TableCell>
                            <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>Anyag értéke</TableCell>
                            <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>Munka értéke</TableCell>
                            <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>A selejt készítésének művelete</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={1}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} onChange={props.handleChange} name={"material"}/>
                            </TableCell>
                            <TableCell colSpan={1}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} onChange={props.handleChange} name={"valueOfMaterial"}/>
                            </TableCell>
                            <TableCell colSpan={1}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} onChange={props.handleChange} name={"valueOfWork"}/>
                            </TableCell>
                            <TableCell colSpan={1}>
                                <Autocomplete getOptionLabel={(taskType) => taskType.name} popupIcon={null}
                                              sx={hideBorderBottom}
                                              onChange={(e, v) => props.handleChange(e, v, "operation")}
                                              renderInput={(params) => (
                                                  <TextField {...params} variant="standard"/>
                                              )} options={props.taskTypes || []}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4} sx={headerCell}>A selejt műszaki leírása</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} minRows={3} onChange={props.handleChange} name={"description"}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4} sx={headerCell}>A selejt oka</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} minRows={3} onChange={props.handleChange} name={"reason"}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={1} sx={headerCell}>Selejtkár összesen</TableCell>
                            <TableCell colSpan={1} sx={headerCell}>Kártérítés összege</TableCell>
                            <TableCell colSpan={1} sx={headerCell}>Kártérítést kiszabta</TableCell>
                            <TableCell colSpan={1} sx={headerCell}>Hiba okozó tudomásul vette</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={1}>
                                <TextField type="text" fullWidth={true} variant="standard"
                                           sx={hideBorderBottom} onChange={props.handleChange} name={"totalDamageAmount"}/>
                            </TableCell>
                            <TableCell colSpan={1}>
                                <TextField type="text" fullWidth={true} variant="standard"
                                           sx={hideBorderBottom} onChange={props.handleChange} name={"compensation"}/>
                            </TableCell>
                            <TableCell colSpan={1}>
                                <Autocomplete getOptionLabel={(user) => user.name} popupIcon={null}
                                              sx={hideBorderBottom}
                                              onChange={(e, v) => props.handleChange(e, v, "handler")}
                                              renderInput={(params) => (
                                                  <TextField {...params} variant="standard"/>
                                              )} options={props.users || []}/>
                            </TableCell>
                            <TableCell colSpan={1}>Igen/Nem</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4} sx={headerCell}>Intézkedés</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           multiline={true} minRows={3} onChange={props.handleChange} name={"todo"}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2} sx={headerCell}>Kelt</TableCell>
                            <TableCell colSpan={1} sx={headerCell}>Selejt felvevő neve</TableCell>
                            <TableCell colSpan={1} sx={headerCell}>Sorszám</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <TextField type="text" fullWidth={true} variant="standard" sx={hideBorderBottom}
                                           onChange={props.handleChange} name={"date"}/>
                            </TableCell>
                            <TableCell colSpan={1}>
                                <Autocomplete getOptionLabel={(user) => user.name} popupIcon={null}
                                              sx={hideBorderBottom}
                                              onChange={(e, v) => props.handleChange(e, v, "taker")}
                                              renderInput={(params) => (
                                                  <TextField {...params} variant="standard"/>
                                              )} options={props.users || []}/>
                            </TableCell>
                            <TableCell colSpan={1}>S123</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </div>
    );
});

const PrintableDefectReport = forwardRef((props, ref) => (
    <div ref={ref}>
        <Paper sx={{margin: "auto", width: "200mm", height: "287mm"}}>
            <Table sx={{
                '& td': {border: '1px solid black', padding: "5px !important", fontSize: "16px !important", tableLayout: "fixed"}
            }}>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={4} sx={headerCell}>Selejt jelentés</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1} sx={headerCell}>Projektszám</TableCell>
                        <TableCell colSpan={1} sx={headerCell}>Munkaszám</TableCell>
                        <TableCell colSpan={2} sx={headerCell}>Selejt mennyiség</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1}>P123</TableCell>
                        <TableCell colSpan={1}>M123</TableCell>
                        <TableCell colSpan={2}>
                            <div style={printableFieldStyle}>{props.data.amount}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2} sx={headerCell}>Hiba okozó neve</TableCell>
                        <TableCell colSpan={2} sx={headerCell}>Munkadarab megnevezése</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <div style={printableFieldStyle}>{props.data.defectCausers?.map(u => u.name).join(', ')}</div>
                        </TableCell>
                        <TableCell colSpan={2}>
                            <div style={printableFieldStyle}>{props.data.nameOfWorkpiece}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>Selejt anyaga</TableCell>
                        <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>Anyag értéke</TableCell>
                        <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>Munka értéke</TableCell>
                        <TableCell colSpan={1} sx={{...headerCell, width: "25%"}}>A selejt készítésének művelete</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.material}</div>
                        </TableCell>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.valueOfMaterial}</div>
                        </TableCell>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.valueOfWork}</div>
                        </TableCell>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.operation?.name}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4} sx={headerCell}>A selejt műszaki leírása</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4}>
                            <div style={printableFieldStyle}>{props.data.description}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4} sx={headerCell}>A selejt oka</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4}>
                            <div style={printableFieldStyle}>{props.data.reason}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1} sx={headerCell}>Selejtkár összesen</TableCell>
                        <TableCell colSpan={1} sx={headerCell}>Kártérítés összege</TableCell>
                        <TableCell colSpan={1} sx={headerCell}>Kártérítést kiszabta</TableCell>
                        <TableCell colSpan={1} sx={headerCell}>Hiba okozó tudomásul vette</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.damageAmount}</div>
                        </TableCell>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.compensation}</div>
                        </TableCell>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.handler?.name}</div>
                        </TableCell>
                        <TableCell colSpan={1}>Igen/Nem</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4} sx={headerCell}>Intézkedés</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={4}>
                            <div style={printableFieldStyle}>{props.data.todo}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2} sx={headerCell}>Kelt</TableCell>
                        <TableCell colSpan={1} sx={headerCell}>Selejt felvevő neve</TableCell>
                        <TableCell colSpan={1} sx={headerCell}>Sorszám</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <div style={printableFieldStyle}>{props.data.date}</div>
                        </TableCell>
                        <TableCell colSpan={1}>
                            <div style={printableFieldStyle}>{props.data.taker?.name}</div>
                        </TableCell>
                        <TableCell colSpan={1}>S123</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    </div>
));